  export const calculateItemsPerPage = () => {
    const MIN_ITEMS = 10;
    const viewportHeight = window.innerHeight;
    const headerHeight = 100; 
    const rowHeight = 60; 
    const availableHeight = viewportHeight - headerHeight;
    const newItemsPerPage = Math.max(Math.floor(availableHeight / rowHeight), MIN_ITEMS);
    sessionStorage.setItem('itemsPerPage', newItemsPerPage.toString());
  };

